import { FormControlLabel, Radio } from "@mui/material";
import useCustomBranding from "hooks/useCustomBranding";

type LabelPosition = "start" | "end" | "top" | "bottom";

interface RadioBtnProps {
  value: any;
  labelContent?: React.ReactNode | string;
  checked?: boolean;
  labelPosition?: LabelPosition;
  className?: string;
  handleChange?: any;
  disabled?: boolean;
  sx?: any;
}

export const RadioBtn: React.FC<RadioBtnProps> = ({
  value,
  labelContent,
  checked,
  labelPosition = "end",
  className,
  handleChange,
  disabled,
  sx,
}) => {
  const { primaryColor } = useCustomBranding();
  return (
    <FormControlLabel
      className={className}
      value={value}
      disabled={disabled}
      control={
        <Radio
          sx={{
            "&.Mui-checked": {
              color: primaryColor,
              ...sx,
            },
            "&:hover": {
              backgroundColor: "transparent",
            },
            "&:focus": {
              backgroundColor: "none",
              boxShadow: "none",
            },
            ...sx,
          }}
          disableRipple
          checked={checked}
          onChange={handleChange}
        />
      }
      label={labelContent}
      labelPlacement={labelPosition}
    />
  );
};
